var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcLikeFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26.468 10.658a6.7 6.7 0 0 0-1.45-2.119 6.7 6.7 0 0 0-2.139-1.42 6.7 6.7 0 0 0-2.607-.52A6.78 6.78 0 0 0 16 8.113a6.778 6.778 0 0 0-4.27-1.512 6.7 6.7 0 0 0-2.608.52 6.72 6.72 0 0 0-3.589 3.538A6.6 6.6 0 0 0 5 13.265c0 .851.173 1.74.516 2.642.288.755.7 1.538 1.228 2.329.835 1.25 1.984 2.555 3.41 3.878 2.363 2.193 4.704 3.707 4.803 3.769l.603.389a.82.82 0 0 0 .879 0l.604-.39c.099-.063 2.437-1.575 4.803-3.768 1.426-1.323 2.574-2.627 3.41-3.878.527-.791.942-1.574 1.227-2.329.344-.903.517-1.79.517-2.642a6.5 6.5 0 0 0-.532-2.607"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLikeFilled);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };